import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import Notiflix from "notiflix";

import {
  Input,
  Row,
  Card,
  Form,
  Statistic,
  Col,
  Divider,
  Spin,
  Table,
  Typography,
  Layout,
  Collapse,
  Select,
  DatePicker,
  InputNumber,
  Button,
  Modal,
  Tooltip,
  List,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  DownloadOutlined,
  PlusCircleOutlined,
  LeftOutlined,
} from "@ant-design/icons";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import CustomButton from "../../../components/custom/CustomButton";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../systemAdmin.config";
import dayjs from "dayjs";
import { accountStatus } from "../../../components/facilities/AccountFacility";
import styles from "../../../assets/styles/styles";

const { TextArea } = Input;
const { Content } = Layout;
const { Panel } = Collapse;

const EditTillConfiguration = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const { Text, Title } = Typography;
  const isLienAllowed = Form.useWatch("lienAllowed", form);
  const [templateProdDetail, setTemplateProdDetail] = useState({});
  // CHARGES FORM REQURED VARIABLES
  const [chargeTableCount, setChargeTableCount] = useState(0);
  const [chargeTableSource, setChargeTableSource] = useState([]);
  const [chargesOptions, setChargesOptions] = useState([]);
  // DECLARED VARIABLES FOR CHARRGES FORM
  const [chargesValue, setChargesValue] = useState(null);
  const [chargeList, setChargeList] = useState([]);
  const [isLimitModalOpen, setIsLimitModalOpen] = useState(false);
  const [isTransactionModalOpen, setIsTransactionModalOpen] = useState(false);
  const [officeData, setOfficeData] = useState([]);
  const [current, setCurrent] = useState(0);
  const [configureLimitTableSource, setConfigurelimitTableSource] = useState(
    []
  );
  const [configureTransactionTableSource, setConfigureTransactionTableSource] =
    useState([]);
  const [codeValueData, setCodeValueData] = useState([]);
  const [transactionCurrencyData, setTransactionCurrencyData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [templateConfigDetail, setTemplateConfigDetail] = useState({});
  const [LimitCount, setLimitCount] = useState(0);
  const [transactionCount, setTransactionCount] = useState(0);
  const [vaultConfigList, setVaultConfigList] = useState([]);

  const [
    selectedbranchConfigValueCurrencyCode,
    setSelectedbranchConfigValueCurrencyCode,
  ] = useState(0);
  const [selectedVaultConfigValue, setSelectedVaultConfigValue] = useState(7);
  // ENDPOINT DECLARED VARIABLES
  const [formData, setFormData] = useState({
    authForm: null,
    branchCcyRestrConfs: null,
    branchOperationTransactionType: null,
  });

  useEffect(() => {
    // getOffices();
    // getCurrencies();
    // getValutValues();
    // getTellerTransactionType();

    getVaultConfigList();
    getTillConfigurationId();
  }, []);

  useEffect(() => {
    if (selectedVaultConfigValue > 0) {
      getVaultCurrencyrestrById();
    }
  }, [selectedVaultConfigValue]);

  const getOffices = () => {
    setIsLoading(true);

    const url = apiConfig.Offices;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        // setTemplateConfigDetail(res);
        const objDetails = res;
        let tempOfficeData = [];

        objDetails?.forEach((element) => {
          tempOfficeData.push({
            value: element.id,
            label: element.name,
          });
        });

        setOfficeData(tempOfficeData);

        setIsLoading(false);
      }
    });
  };

  const getCurrencies = () => {
    setIsLoading(true);

    const url = apiConfig.Currencies;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetails = res;
        let tempCurrencyData = [];

        objDetails?.selectedCurrencyOptions?.forEach((element) => {
          tempCurrencyData.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        setCurrencyData(tempCurrencyData);

        setIsLoading(false);
      }
    });
  };

  const handleChargeDelete = (key) => {
    console.log(key);
    // console.log(chargeTableSource.name);
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.name, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = chargeTableSource.filter((item) => item.id !== key.id);
        setChargeTableSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const limitColumn = [
    {
      title: "Currency",
      dataIndex: "currencyCode",
    },
    {
      title: "Authorization Threshold",
      dataIndex: "authThresholdAmount",
    },
    {
      title: "Daily Transaction Limit",
      dataIndex: "transactionLimit",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        configureLimitTableSource.length >= 1 ? (
          <Tooltip title={`Remove`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleBranchLimitDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  const transactionColumn = [
    {
      title: "Currency",
      dataIndex: "currencyCode",
    },
    // {
    //   title: "Transaction Type",
    //   dataIndex: "transactionType",
    // },
    {
      title: "Transaction Type",
      dataIndex: "transactionTypeValue",
    },
    {
      title: "Transaction Type Limit",
      dataIndex: "transactionTypeLimit",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        configureTransactionTableSource.length >= 1 ? (
          <Tooltip title={`Remove`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleTransactionLimitDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  function onCancel() {
    navigate("/sya0600", { state: state });
  }

  const handleBranchLimitDelete = (key) => {
    let action = "Delete  ";

    Notiflix.Confirm.show(
      "please confirm action",
      "",
      "Yes",
      "No",

      function () {
        const newData = configureLimitTableSource.filter(
          (item) => item.id !== key.id
        );
        setConfigurelimitTableSource(newData);

        // Update transaction currency data after removing a limit
        const tempNewCurrencyData = newData.map((configItem) => {
          const matchedCurrency = currencyData?.find(
            (currencyItem) => currencyItem.value === configItem.currencyCode
          );

          return {
            value: configItem.currencyCode,
            label: matchedCurrency?.label || configItem.currencyCode,
          };
        });

        setTransactionCurrencyData(tempNewCurrencyData);
      },

      function () {
        // No button
      }
    );
  };

  const handleTransactionLimitDelete = (key) => {
    console.log(key);

    let action = "Delete  ";
    // let label = BOM.SubstringFormat(key.fundSourceAccountValue, 20);

    Notiflix.Confirm.show(
      "please confirm action",
      "",
      "Yes",
      "No",

      function () {
        const newData = configureTransactionTableSource.filter(
          (item) => item.id !== key.id
        );
        setConfigureTransactionTableSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const getVaultConfigList = () => {
    let body = { session };

    BOM.FetchReqAction(body, apiConfig.VaultConfig, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const dropdownOptions = res.map((element) => ({
          value: element.operationId2.id,
          label: element.operationId2.officeId.name,
        }));

        setVaultConfigList(dropdownOptions);
        setIsLoading(false);
      }
    });
  };

  const getVaultCurrencyrestrById = () => {
    let body = { session };
    // selectedVaultConfigValue
    let url = `${
      apiConfig.VaultConfig +
      `/vaultcurrencyrestr` +
      `/${selectedVaultConfigValue}`
    }`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        console.log(res);

        const currencyOptions = res.map((item) => ({
          value: item.currencyCode,
          label: item.currencyCode,
        }));

        setSelectedbranchConfigValueCurrencyCode(currencyOptions);
      }
    });
  };

  const getTillConfigurationId = () => {
    setIsLoading(true);

    const url = apiConfig.Tellerconfig + `/${state.id}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        // setTemplateConfigDetail(res);
        const objDetails = res;
        // let tempOfficeData = [];

        // objDetails?.forEach((element) => {
        //   tempOfficeData.push({
        //     value: element.id,
        //     label: element.name,
        //   });
        // });

        console.log(objDetails);

        form.setFieldsValue({
          vaultId: objDetails.vaultId.id,
          description: objDetails.description,
          allowDenomTracking: objDetails.allowDenomTracking,
          printTransactionReceipt: objDetails.printTransactionReceipt,
          allowTransactionReversal: objDetails.allowTransactionReversal,
        });

        const authForm = {
          vaultId: objDetails.vaultId.id,
          description: objDetails.description,
          allowDenomTracking: objDetails.allowDenomTracking,
          printTransactionReceipt: objDetails.printTransactionReceipt,
          allowTransactionReversal: objDetails.allowTransactionReversal,
        };

        setFormData({
          authForm,
        });

        setSelectedVaultConfigValue(objDetails.vaultId.id);
        setConfigurelimitTableSource(objDetails.tellerCcyRestrConfData);

        setIsLoading(false);
      }
    });
  };

  console.log(configureLimitTableSource);
  const onSubmit = (formValues) => {
    // console.log(chargeTableSource);
    // setConfigurelimitTableSource;
    // let tempChargeArray = [];
    // chargeTableSource.forEach((element, index) => {
    //   if (element.feeOnMonthDay === "-") {
    //     tempChargeArray.push({
    //       chargeId: element.chargeId,
    //       amount: element.amountToUse,
    //     });
    //   } else {
    //     tempChargeArray.push({
    //       chargeId: element.chargeId,
    //       amount: element.amountToUse,
    //       feeOnMonthDay: BOM.DateTimeWithoutYear(
    //         element.feeOnMonthDay,
    //         "only-date"
    //       ),
    //     });
    //   }
    // });

    // delete formValues.chargeId;

    // console.log(formValues);
    // return;

    const tellerCcyRestrConfs = configureLimitTableSource.map((item) => ({
      tellerCcyRestrConf: {
        locale: "en",
        currencyCode: item.currencyCode,
        authThresholdAmount: item.authThresholdAmount.toString(),
        transactionLimit: item.transactionLimit.toString(),
      },
    }));
    const url = `${apiConfig.Tellerconfig}/${state.id}`;

    const body = {
      id: state.id,
      ccyRestrId:state.id,
      ...formValues,
      tellerCcyRestrConfs,
      method: "PUT",
      session,
    };

    console.log(body)
    // return
    // setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.updateSavingsAccountMsg);
        navigate("/sya0600",);
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={false}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.editTillConfiguration}
        pageItems={staticConfig.editTillConfigurationBreadcrumbItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{
                    marginTop: "auto",
                    marginBottom: "auto",
                    fontSize: 15,
                  }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Divider style={{ marginTop: 5, marginBottom: 30 }} />
            <Row>
              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.authorizationInfo}
                </Title>
              </Divider>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.vault}
                  name={"vaultId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.vault),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.vault,
                      "select"
                    )}
                    options={vaultConfigList}
                    allowClear
                    showSearch
                    onChange={(val) => setSelectedVaultConfigValue(val)}
                    disabled={true}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  name="description"
                  label={labelConfig.tillProfileName}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: BOM.CheckReqFld(labelConfig.tillProfileName),
                  //   },
                  // ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.tillProfileName
                    )}
                    // style={styles.ofInputFieldNumber}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.denominationTracking}
                  name={"allowDenomTracking"}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Required Field",
                  //   },
                  // ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    showSearch
                    options={staticConfig.statusData}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.printReceipt}
                  name={"printTransactionReceipt"}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Required Field",
                  //   },
                  // ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    showSearch
                    options={staticConfig.statusData}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.transactionReversal}
                  name={"allowTransactionReversal"}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Required Field",
                  //   },
                  // ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    showSearch
                    options={staticConfig.statusData}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.limitsInfo}
              </Title>
            </Divider>
            <BranchLimitModal
              isLimitModalOpen={isLimitModalOpen}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              setIsLimitModalOpen={setIsLimitModalOpen}
              //   paymentTypeOptions={paymentTypeOptions}
              //   assetAccountOptions={assetAccountOptions}
              setConfigurelimitTableSource={setConfigurelimitTableSource}
              configureLimitTableSource={configureLimitTableSource}
              LimitCount={LimitCount}
              setLimitCount={setLimitCount}
              currencyData={currencyData}
              transactionCurrencyData={transactionCurrencyData}
              setTransactionCurrencyData={setTransactionCurrencyData}
              selectedVaultConfigValue={selectedVaultConfigValue}
              selectedbranchConfigValueCurrencyCode={
                selectedbranchConfigValueCurrencyCode
              }
            />

            {configureLimitTableSource?.length > 0 && (
              <>
                <Divider orientation="left" orientationMargin="0">
                  <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                    {configureLimitTableSource.length > 1
                      ? "Added Branch Limits"
                      : "Added Branch Limit"}
                  </Title>
                </Divider>
                <Table
                  columns={limitColumn}
                  dataSource={configureLimitTableSource}
                  bordered
                  pagination={{
                    position: "bottomCentre",
                    pageSize: "10",
                  }}
                />
              </>
            )}

            {/* <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.transactionInfo}
              </Title>
            </Divider>
            <BranchTransactionLimitModal
              isTransactionModalOpen={isTransactionModalOpen}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              setIsTransactionModalOpen={setIsTransactionModalOpen}
              setConfigureTransactionTableSource={
                setConfigureTransactionTableSource
              }
              configureTransactionTableSource={configureTransactionTableSource}
              transactionCount={transactionCount}
              setTransactionCount={setTransactionCount}
              currencyData={currencyData}
              // currencyData={currencyData}
              codeValueData={codeValueData}
              transactionCurrencyData={transactionCurrencyData}
              setTransactionCurrencyData={setTransactionCurrencyData}
            /> */}

            {/* {configureTransactionTableSource?.length > 0 && (
              <>
                <Divider orientation="left" orientationMargin="0">
                  <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                    {configureTransactionTableSource.length > 1
                      ? "Added Branch Transactions"
                      : "Added Branch Transaction"}
                  </Title>
                </Divider>
                <Table
                  columns={transactionColumn}
                  dataSource={configureTransactionTableSource}
                  bordered
                  pagination={{
                    position: "bottomCentre",
                    pageSize: "10",
                  }}
                />
              </>
            )} */}

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#92428B"
                colorText="white"
                hoverBackground="#AD4EA7"
              />
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};
export default EditTillConfiguration;

const BranchLimitModal = (props) => {
  const {
    isLoading,
    setIsLoading,
    setConfigurelimitTableSource,
    configureLimitTableSource,
    isLimitModalOpen,
    setIsLimitModalOpen,
    LimitCount,
    setLimitCount,
    currencyData,
    setTransactionCurrencyData,
    transactionCurrencyData,
    selectedVaultConfigValue,
    selectedbranchConfigValueCurrencyCode,
  } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsLimitModalOpen(true);
  };
  const handleOk = () => {
    setIsLimitModalOpen(false);
  };
  const handleCancel = () => {
    setIsLimitModalOpen(false);
  };

  const handleBranchLimitSave = (formValues) => {
    const newAuthLimit = {
      key: LimitCount,
      id: LimitCount,
      authThresholdAmount: formValues.authThresholdAmount,
      currencyCode: formValues.currencyCode,
      transactionLimit: formValues.transactionLimit,
    };
    setLimitCount(LimitCount + 1);

    let foundLimits = configureLimitTableSource.find(
      (item) => item.currencyCode === newAuthLimit?.currencyCode
    );
    if (foundLimits) {
      BOM.AlertMsg(cnt.WARNING, "No duplicate Limit allowed!");
      return;
    }

    // Add the new limit to the table source
    const updatedLimitsSource = [...configureLimitTableSource, newAuthLimit];
    setConfigurelimitTableSource(updatedLimitsSource);

    // Update the transaction currency data after adding new limit
    const tempNewCurrencyData = updatedLimitsSource.map((configItem) => {
      const matchedCurrency = currencyData?.find(
        (currencyItem) => currencyItem.value === configItem.currencyCode
      );

      return {
        value: configItem.currencyCode,
        label: matchedCurrency?.label || configItem.currencyCode,
      };
    });

    setTransactionCurrencyData(tempNewCurrencyData);
    useForm.resetFields();
  };

  return (
    <Row>
      <Button
        type="primary"
        shape="round"
        className="of-primaryBtnColor"
        onClick={showModal}
      >
        <PlusCircleOutlined />
        &nbsp; {"Add"}
      </Button>

      <Modal
        title="Limit Information Setup"
        open={isLimitModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleBranchLimitSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"currencyCode"}
                label={labelConfig.currency}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.currency),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.currency,
                    "select"
                  )}
                  options={selectedbranchConfigValueCurrencyCode}
                  allowClear
                  showSearch
                  // onChange={onChangeCurrency}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="authThresholdAmount"
                label={labelConfig.authThreshold}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.authThreshold),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.authThreshold
                  )}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="transactionLimit"
                label={labelConfig.transactionLimit}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.transactionLimit),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.transactionLimit
                  )}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};

const BranchTransactionLimitModal = (props) => {
  const {
    isLoading,
    setIsLoading,
    setConfigureTransactionTableSource,
    configureTransactionTableSource,
    isTransactionModalOpen,
    setIsTransactionModalOpen,
    transactionCount,
    setTransactionCount,
    transactionCurrencyData,
    currencyData,
    codeValueData,
    setTransactionCurrencyData,
  } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsTransactionModalOpen(true);
  };
  const handleOk = () => {
    setIsTransactionModalOpen(false);
  };
  const handleCancel = () => {
    setIsTransactionModalOpen(false);
  };

  const handleBranchTransactionSave = (formValues) => {
    // console.log(formValues);

    const newTransactionLimit = {
      key: transactionCount,
      id: transactionCount,
      transactionType: formValues.transactionType,
      transactionTypeValue: formValues.transactionType
        ? [
            {
              value: 90,
              label: "WTH",
              position: 0,
              description: "Withdrawal Transaction",
              active: true,
              mandatory: false,
            },
            {
              value: 91,
              label: "DEP",
              position: 1,
              description: "Deposit Transaction",
              active: true,
              mandatory: false,
            },
            {
              value: 92,
              label: "TRF",
              position: 2,
              description: "Transfer Transaction",
              active: true,
              mandatory: false,
            },
          ].find((item) => item.value === formValues.transactionType).label
        : "-",
      currencyCode: formValues.currencyCode,
      transactionTypeLimit: formValues.transactionTypeLimit,
    };
    setTransactionCount(transactionCount + 1);

    let duplicateFound = configureTransactionTableSource.some(
      (item) =>
        item.currencyCode === newTransactionLimit.currencyCode &&
        item.transactionTypeValue === newTransactionLimit.transactionTypeValue
    );

    if (duplicateFound) {
      BOM.AlertMsg(
        cnt.WARNING,
        "Duplicate transaction type and currency combination not allowed!"
      );
      return;
    }
    setConfigureTransactionTableSource([
      ...configureTransactionTableSource,
      newTransactionLimit,
    ]);

    useForm.resetFields();
  };

  return (
    <Row>
      <Button
        type="primary"
        shape="round"
        className="of-primaryBtnColor"
        onClick={showModal}
      >
        <PlusCircleOutlined />
        &nbsp; {"Add"}
      </Button>

      <Modal
        title="Transaction Limit Setup"
        open={isTransactionModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleBranchTransactionSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"currencyCode"}
                label={labelConfig.currency}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.currency),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.currency,
                    "select"
                  )}
                  options={transactionCurrencyData}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="transactionType"
                label={labelConfig.transcationType}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.transcationType),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.transcationType,
                    "select"
                  )}
                  options={[
                    {
                      value: 90,
                      label: "WTH",
                      position: 0,
                      description: "Withdrawal Transaction",
                      active: true,
                      mandatory: false,
                    },
                    {
                      value: 91,
                      label: "DEP",
                      position: 1,
                      description: "Deposit Transaction",
                      active: true,
                      mandatory: false,
                    },
                    {
                      value: 92,
                      label: "TRF",
                      position: 2,
                      description: "Transfer Transaction",
                      active: true,
                      mandatory: false,
                    },
                  ]}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="transactionTypeLimit"
                label={labelConfig.limit}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.limit),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.limit)}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};
